import { useAuth } from "@/lib/auth";
import { useTechLocationReporter } from "@/lib/use-tech-location-reporter";

/**
 * Mount point for the opt-in field GPS reporter (live-GPS spike).
 *
 * Renders nothing. It runs the reporter ONLY for authenticated
 * technician-role users, and the reporter itself is additionally gated on the
 * `field.gpsEnabled` localStorage flag (default OFF). Mounted from the field
 * shell so it never spins up for office/admin users.
 */
export function TechLocationReporter() {
    const { user, isField, isOffice, isAdmin } = useAuth();
    const techOnly = isField && !isOffice && !isAdmin;
    useTechLocationReporter(!!user && techOnly);
    return null;
}
